exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3iBi9rlySBurP-gf1UO1ZR{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}html[dir] ._3iBi9rlySBurP-gf1UO1ZR{padding-top:35px}._1HkC6GxHZH37OQtstOh4ip{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}html[dir=ltr] ._3rUUKTxICEJBYZCe4XNaC7{padding-right:30px}html[dir=rtl] ._3rUUKTxICEJBYZCe4XNaC7{padding-left:30px}", ""]);

// exports
exports.locals = {
	"safeLinksContainer": "_3iBi9rlySBurP-gf1UO1ZR",
	"safeLinks_toggleBtn_Container": "_1HkC6GxHZH37OQtstOh4ip",
	"safeLinks_description": "_3rUUKTxICEJBYZCe4XNaC7"
};